import React, { Component } from 'react';
// import Lottie from 'lottie-react';
import dynamic from 'next/dynamic';
// import { DotLottieReact } from '@lottiefiles/dotlottie-react';
import PropTypes from 'prop-types';
// import AppAdaptiveOutlineButton from './AppAdaptiveOutlineButton'; // Replace with actual import path
// import utils from './utils'; // Replace with actual import path
// import { requestedBooksNotifier, addToRequestsDetails, getIsPremiumUser } from './actions';
import { bookProgressStage, bookRequestLimit, staticAssetsPrefix } from '../../lib/utils';
import { getIsPremiumUser } from '../../lib/fileUtils';
import { Button, notification } from 'antd';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { addToRequestsDetails } from '../../actions/RequestActions';
// import LottieComponent from './LottieComponent';
const LottieComponent = dynamic(() => import('./LottieComponent'), {
    ssr: false, // Set to true if you want server-side rendering
    // loading: () => <p>Loading...</p>, // Optional loading component
});

// const DotLottieReact = dynamic(() => import('@lottiefiles/dotlottie-react'), { ssr: false });
// const DotLottieReact = dynamic(() => import('@lottiefiles/dotlottie-react').then((mod) => mod.DotLottieReact), { ssr: false });
// const DotLottie = dynamic(() => import('@lottiefiles/dotlottie-react'), { ssr: false });

const data = {
    10: {
        title: "This book summary is almost done and will be available soon!",
        subtitle:
            "Want it completed sooner? Request it below, and we’ll prioritize it within 5 working days!",
        image: "bookConstruction2",
    },
    20: {
        title: "This book is currently in beta and available to select users.",
        subtitle:
            "Want it released to everyone sooner? Request it below, and we’ll prioritize it to release within 5 working days!",
        image: "beta2",
    },
    30: {
        title: "Audio for this book is in progress.",
        subtitle:
            "Want the audio sooner? Request it below, and we’ll prioritize adding it in 3 working days!",
        image: "audioWave2",
    },
};

class BookInProgress extends Component {
    constructor(props) {
        super(props);
        this.state = {};
    }

    handleOnPressed = (requested) => {
        const { itunesData, requestedBooks } = this.props;
        const bookProgressStageVal = bookProgressStage(itunesData);

        if (requested) {
            return;
        }

        if (!getIsPremiumUser()) {
            notification.info({
                duration: 0,
                message: 'Please move to premium version to request book update.',
            });
            return;
        }

        const requests = requestedBooks; //requestedBooksNotifier.value;
        const now = new Date();
        const startOfMonth = new Date(now.getFullYear(), now.getMonth(), 1);
        const endOfMonth = new Date(now.getFullYear(), now.getMonth() + 1, 0);

        const filteredObjects = Object.values(requests).filter((obj) => {
            const timestamp = obj.time || 0;
            return (
                timestamp >= startOfMonth.getTime() &&
                timestamp <= endOfMonth.getTime() &&
                (obj.type || 1) < 30
            );
        });

        if (filteredObjects.length >= bookRequestLimit) {
            // utils.showGenericDialog(
            //     'Request Limit',
            //     'You have reached the request limit for this month. Limits reset first of every month.'
            // );
            notification.info({
                duration: 0,
                message: 'You have reached the request limit for this month. Limits reset first of every month.',
            });
            return;
        }

        this.props.addToRequestsDetails(
            itunesData.collectionName,
            itunesData.artistName,
            Date.now(),
            itunesData.collectionId,
            bookProgressStageVal,
        );

        let message =
            "Thank you for your request! We've received it and will prioritize this book.";

        if (bookProgressStageVal === 10) {
            message =
                "Thank you for your request! We've received it and will prioritize making this book available within the next 5 working days.";
        } else if (bookProgressStageVal === 20) {
            message =
                "Thank you for your request! We've received it and will prioritize the beta process to make it available to all users within the next 5 working days.";
        } else if (bookProgressStageVal === 30) {
            message =
                "Thank you for your request! We've received it and will prioritize adding audio within the next 5 working days.";
        }

        notification.info({
            duration: 0,
            message: message,
        });
        // utils.showGenericDialog('Request Confirmed', message);
    };

    render() {
        const { itunesData, requestedBooks, lottieWidth = 600 } = this.props;
        const bookProgressStageVal = bookProgressStage(itunesData);
        const currMap = data[bookProgressStageVal] || {};

        return (
            <div style={{ textAlign: 'center' }}>
                <div style={{ width: `${lottieWidth}px`, textAlign: 'center', margin: 'auto' }}>
                    {/* <Lottie
                        animationData={require(`../assets/images/introNew/lottie/${currMap.image}.json`)}
                        style={{ width: lottieWidth }}
                    /> */}
                    {/* <DotLottieReact
                        src={`${staticAssetsPrefix}/static/images/lottie/${currMap.image}.lottie`}
                        loop
                        autoplay
                    /> */}
                    <LottieComponent image={currMap.image} lottieWidth={lottieWidth} />
                </div>
                {bookProgressStageVal == 10 && <div style={{ height: 16 }} />}
                {itunesData && (
                    <>
                        <h3 style={{ fontSize: 20, fontWeight: 500 }}>{currMap.title || ''}</h3>
                        <p style={{ fontWeight: 500 }}>{currMap.subtitle || ''}</p>
                        <div style={{ height: 24 }} />
                        <Button type='primary' onClick={this.handleOnPressed.bind(this, requestedBooks[itunesData.collectionId])}
                        >{requestedBooks[itunesData.collectionId] ? 'Requested' : 'Request'}</Button>
                        {/* <AppAdaptiveOutlineButton
                            onClick={() => this.handleOnPressed(requestedBooksNotifier.value[itunesData.collectionId])}
                            color={
                                requestedBooksNotifier.value[itunesData.collectionId]
                                    ? 'rgba(0,0,0,0.6)'
                                    : null
                            }
                        >
                            {requestedBooksNotifier.value[itunesData.collectionId] ? 'Requested' : 'Request'}
                        </AppAdaptiveOutlineButton> */}
                    </>
                )}
            </div>
        );
    }
}

BookInProgress.propTypes = {
    itunesData: PropTypes.object,
    requestedBooks: PropTypes.object,
    lottieWidth: PropTypes.number,
    addToRequestsDetails: PropTypes.func,
};


const mapStateToProps = (state) => {
    return {
        userDetails: state.userDetails,
        loadingState: state.loadingState,
        // userPlaylists: state.userPlaylists,
        // personalValues: state.personalValues,
        // personalMarkPlayedValues: state.personalMarkPlayedValues,
        requestedBooks: state.requestedBooks,
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        addToRequestsDetails: bindActionCreators(addToRequestsDetails, dispatch),
        // fetchAutoChapters: bindActionCreators(fetchAutoChapters, dispatch),
        // setEpisodeReadProgress: bindActionCreators(setEpisodeReadProgress, dispatch),
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(BookInProgress);
// export default BookInProgress;